import { useImpersonation } from "../../context/ImpersonationContext";

/**
 * Persistent reminder that the screen below is not the viewer's own data.
 *
 * Wears the concept's projected palette rather than a raw amber-500. That is
 * the same treatment every unmeasured or simulated thing in the app carries,
 * and "you are looking at this as someone else" is exactly that kind of
 * claim — not a warning, not an error, just not literally true.
 */
const ImpersonationBanner = () => {
  const { impersonating, setImpersonating } = useImpersonation();

  if (!impersonating) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="z-50 flex items-center justify-center gap-3 bg-[hsl(var(--projected-bg))] px-4 py-2 text-[hsl(var(--projected))]"
    >
      <span className="font-mono text-[9.5px] font-medium uppercase tracking-[0.14em]">
        Impersonating
      </span>
      <span className="text-xs font-medium">{impersonating}</span>
      <button
        type="button"
        onClick={() => setImpersonating(null)}
        className="rounded border border-[hsl(var(--projected-line))] px-2 py-0.5 text-[10px] font-medium transition-colors hover:bg-[hsl(var(--projected))] hover:text-white"
      >
        Stop
      </button>
    </div>
  );
};

export default ImpersonationBanner;
